import * as React from 'react';
import Rheostat, { PublicState } from 'rheostat';
import 'rheostat/css/slider.css';
import 'rheostat/css/slider-horizontal.css';
const classNames = require('classnames');

import Utils from '../common/utils';

interface Props {
	className?: string;
	min: number;
	max: number;
	value: number;
	valuePrefix?: string;
	valueSuffix?: string;
	titlePrefix?: string;
	titleSuffix?: string;
	minSuffix?: string;
	maxSuffix?: string;
	onSliderDragEnd?: () => any;
	onValuesUpdated?: (slider: PublicState) => any;
	snapPoints?: Array<number>;
}

interface RheostatPitProps {
	style?: {};
	children?: {};
}

const RheostatPit: React.StatelessComponent<RheostatPitProps> = ({ style, children }) => {
	return (
		<div className="rheostat-pit" style={style}>
			{children}
		</div>
	);
};

class QuoteSlider extends React.Component<Props> {
	private SLIDER_RANGE = this.props.max - this.props.min;

	render() {
		const { ...props } = this.props;

		return (
			<div className={classNames('quote-slider', props.className)}>
				<h2 className="text-secondary text-center mb-4 rheostat-title">
					{props.titlePrefix && <span className="rheostat-title-prepend">{props.titlePrefix}</span>}
					{props.valuePrefix}
					{Utils.formatNumberWithCommas(props.value)}
					{props.valueSuffix}
					{props.titleSuffix && <span className="rheostat-title-append">{props.titleSuffix}</span>}
				</h2>
				<div className="row mb-5">
					<div className="col-lg-2 text-secondary text-right small d-none d-lg-block rheostat-prepend">
						{props.valuePrefix}
						{Utils.getAbbreviatedNumber(props.min)}{props.minSuffix}
						{props.valueSuffix}
					</div>
					<div className="col-lg-8 d-lg-flex align-items-center">
						<Rheostat
							orientation="horizontal"
							min={Math.round(props.min / props.max * 100 * 10) / 10}
							values={[Math.round(props.value / props.max * 100 * 10) / 10]}
							pitComponent={RheostatPit}
							pitPoints={[
								(0.25 * this.SLIDER_RANGE + props.min) / props.max * 100,
								(0.5 * this.SLIDER_RANGE + props.min) / props.max * 100,
								(0.75 * this.SLIDER_RANGE + props.min) / props.max * 100
							]}
							onSliderDragEnd={props.onSliderDragEnd}
							onValuesUpdated={props.onValuesUpdated}
							snap={false}
							snapPoints={props.snapPoints}
						/>
					</div>
					<div className="col-lg-2 text-secondary text-left small d-none d-lg-block rheostat-append">
						{props.valuePrefix}
						{Utils.getAbbreviatedNumber(props.max)}{props.maxSuffix}
						{props.valueSuffix}
					</div>
				</div>
			</div>
		);
	}
}

export default QuoteSlider;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/quoting/QuoteSlider.tsx